import { For } from "solid-js";

import { InputField } from "./InputField";
import type { UtdoLyrics, UtdoTrack } from "../types";
import { toNullableInt, toNullableString, toString } from "../util/converters";

type TracksEditorProps = {
    track: UtdoTrack;
    lyrics: UtdoLyrics[];
    validate: (track: UtdoTrack) => any;
    cancel: () => any;
};

export function TracksEditor(props: TracksEditorProps) {
    let idRef!: HTMLInputElement;
    let diskRef!: HTMLInputElement;
    let trackRef!: HTMLInputElement;
    let titleRef!: HTMLInputElement;
    let lyricsRef!: HTMLSelectElement;
    let durationRef!: HTMLInputElement;

    const cancel = (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        props.cancel();
    };

    const validate = (ev: Event) => {
        ev.preventDefault();
        ev.stopPropagation();
        const id = toNullableInt(idRef.value);
        const disk = Number.parseInt(diskRef.value, 10);
        const track = Number.parseInt(trackRef.value, 10);
        const title = toNullableString(titleRef.value);
        const lyrics = Number.parseInt(lyricsRef.value, 10);
        const duration = toString(durationRef.value);
        props.validate({
            id,
            disk,
            track,
            title,
            lyrics,
            duration,
        });
    };

    return <form onSubmit={validate} autocomplete="off">
        <input ref={idRef} type="hidden" value={props.track.id}/>
        <InputField
            ref={diskRef}
            type="number"
            id="track-disk"
            label="Disque"
            required
            disabled
            value={props.track.disk}/>
        <InputField
            ref={trackRef}
            type="number"
            id="track-track"
            label="Piste"
            step="1"
            min="1"
            required
            value={props.track.track}/>
        <InputField
            ref={titleRef}
            type="text"
            id="track-title"
            label="Titre (facultatif, si vide, le tite de la chanson sera utilisé)"
            value={props.track.title ?? ""}/>
        <select ref={lyricsRef} value={props.track.lyrics}>
            <option value="0">Aucune</option>
            <For each={props.lyrics}>
                {(song) => <option value={song.id}>{song.title}</option>}
            </For>
        </select>
        <InputField
            ref={durationRef}
            type="time"
            id="track-duration"
            label="Durée"
            step="1"
            required
            value={props.track.duration}/>
        <div class="actions">
            <input type="submit" value="Enregistrer" class="accent" />
            <button onClick={cancel}>Annuler</button>
        </div>
    </form>
}